import React, { useRef, useCallback, useEffect } from 'react';
import { Notification } from './Notification.js';
import { getAutoClose } from './utils/utils.js';
import { jsx } from 'react/jsx-runtime';

const NotificationWrapper = ({
  notification,
  autoClose,
  onHide,
  innerRef,
  NotificationComponent,
  ...others
}) => {
  const {
    autoClose: notificationAutoClose,
    ...notificationProps
  } = notification;
  const autoCloseTimeout = getAutoClose(autoClose, notificationAutoClose);
  const hideTimeout = useRef();
  const handleHide = useCallback(() => {
    onHide(notification.id);
    window.clearTimeout(hideTimeout.current);
  }, [notification, onHide]);
  const handleDelayedHide = useCallback(() => {
    if (typeof autoCloseTimeout === 'number') {
      hideTimeout.current = window.setTimeout(handleHide, autoCloseTimeout);
    }
  }, [autoCloseTimeout, handleHide]);
  const cancelDelayedHide = () => {
    clearTimeout(hideTimeout.current);
  };
  useEffect(() => {
    if (typeof notification.onOpen === 'function') {
      notification.onOpen(notification);
    }
  }, [notification]);
  useEffect(() => {
    handleDelayedHide();
    return cancelDelayedHide;
  }, [autoClose, handleDelayedHide]);
  const props = {
    ...notificationProps,
    ...others,
    onClose: handleHide,
    onMouseEnter: cancelDelayedHide,
    onMouseLeave: handleDelayedHide,
    ref: innerRef,
    children: notification.message
  };
  if (NotificationComponent) {
    return /*#__PURE__*/React.cloneElement(NotificationComponent, props);
  }
  return /*#__PURE__*/jsx(Notification, {
    ...props
  });
};
NotificationWrapper.displayName = 'NotificationWrapper';

export { NotificationWrapper };
